module.exports = __webpack_public_path__ + "img/project-group.15de06c0.svg";